// extracted by mini-css-extract-plugin
export default {"holder":"BlockToolbox_holder__RK5+K","toolbox":"BlockToolbox_toolbox__dxoi4","toolboxInner":"BlockToolbox_toolboxInner__LN3A0"};